import { Routes } from '@angular/router';

import { PASSWORD_ROUTES } from './password/password.route';
import { REGISTER_ROUTE } from './register/register.route';
import { ACTIVATE_ROUTE } from './activate/activate.route';
import { SETTINGS_ROUTE } from './settings/settings.route';

export const ACCOUNT_ROUTES: Routes = [
    {
        path: '',
        children: [
            /* REGISTER_ROUTE */ // TODO: Not used actually
            ACTIVATE_ROUTE,
            SETTINGS_ROUTE,
            ...PASSWORD_ROUTES
        ]
    }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/account/account.route.ts